export default __webpack_public_path__ + "static/media/add@3x.a0451464.png";